import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@adc/ui-adc'
import { formatMoneyWithNumeral } from 'common/utils/formatters'
import { ZERO_DOLLARS } from 'common/components/bidBanner/constants'

const SalesDeposit = ({ salesDeposit }) => {
  return (
    <>
      <Text
        className='u-mr-1'
        color='gray'
        content='Sales Deposit'
        data-elm-id='sales_deposit_label'
        size='tiny'
      />
      <Text
        color='gray'
        content={formatMoneyWithNumeral(salesDeposit, ZERO_DOLLARS)}
        data-elm-id='sales_deposit_value'
        size='tiny'
        weight='heavy'
      />
    </>
  )
}

SalesDeposit.propTypes = {
  salesDeposit: PropTypes.number,
}

export default SalesDeposit
